'use client';

import { createContext } from 'react';

import { type DatoLocale } from '@/lib/datocms/types';
import { type Language } from '@/lib/utils/language';
import { type Region } from '@/types';

type LanguageOption = { language: Language; path: string };
type BasePageData = {
  gaPageType: string;
  gaCategory: string;
  languageOptions: LanguageOption[];
};

// Many of these fields are from the old pages version and should be re-examined
export type PageDataContext<
  TCmsData extends Record<string, unknown>,
  TPageData extends Record<string, unknown>
> = {
  params: {
    language: Language;
    region: Region;
    pathParts?: string[];
    slug?: string;
    page?: string;
  };
  locale: DatoLocale;
  cmsData: TCmsData;
  pageData: TPageData & BasePageData;
};

export const PageContext = createContext<PageDataContext<
  Record<string, unknown>,
  Record<string, unknown>
> | null>(null);
